<template>
  <div class="c-radio-button">
    <div
      v-for="(option,index) of options"
      :key="option"
      class="c-radio-button__option"
      role="radiogroup"
    >
      <Btn
        :type="active == index ? 'primary' : 'primary-open'"
        :button-size="['small', 'thin']"
        :aria-label="activeIndex == index ? option + ' currently selected.' : '' "
        @click="buttonClick"
      >
        {{ option }}
      </Btn>
    </div>
  </div>
</template>
<script>
import Btn from "../button/Btn";
export default {
  components:{
    Btn
  },
  props:{
    options: {
      type: Array,
      default:()=> [],
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
      active: 0,
    }
  },
  created() {
    if (this.activeIndex < this.options.length && this.activeIndex >= 0){
      this.active = this.activeIndex;
    } else {
      this.active = 0
    }
  },
  methods:{
    buttonClick(event){
      event.preventDefault()
      for (let [index, option] of this.options.entries()) {
        if (option == event.target.innerHTML.trim()) {
          this.active = index;
        }
      }
      // FIXME use v-model protocol please
      this.$emit('radioChange', event.target.innerHTML.trim());
    }
  }
}
</script>
<style lang="scss" scoped>
  .c-radio-button__option{
    margin:rem(10px);
    display: inline-block;
  }
</style>
